import axios, { AxiosRequestConfig } from "axios";
import { useToast } from "vue-toastification";

const toast = useToast();

const instance = axios.create({
  baseURL: import.meta.env.VITE_BASE_API,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = localStorage.getItem("token_auth");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;

      return config;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      toast.error("Não autorizado");
    }
    if (error.response?.status === 404) {
      toast.error("Não encontrado");
    }

    return Promise.reject(error);
  }
);

export default instance;
